import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { Container, Card, CardBody, Row, Col, Table, TabContent, TabPane, Nav, NavItem, NavLink, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge } from "reactstrap"
import { salesDeveloperPrefix } from "configs/routePrefix"
import { toast } from "react-toastify"
import { SuccessOk } from "configs/statusCode"
import compoundImg from "assets/images/bg.png"
import Pagination from "../Pagination"
import { useSelector, useDispatch } from "react-redux";
import ClientsService from "services/SalesDeveloper/ClientsService"

const ViewClientPage = (props) => {
    const clientsService = new ClientsService()
    const [lead, setLead] = useState(null);
    const [feedbacks, setFeedbacks] = useState([]);
    const [appointments, setAppointments] = useState([]);
    const [deals, setDeals] = useState([]);
    const [activities, setActivities] = useState([]);
    const [activeTab, setActiveTab] = useState("1")
    const [dropdownStatus, setDropdownStatus] = useState(false);
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => AuthData.permissions[data]
    const id = props.match.params.id
    const toggleStausDropdown = () => setDropdownStatus(prevState => !prevState);

    const getLeadData = () => {
        clientsService.find(id).then(response => {
            if (response && response.status === SuccessOk) {
                const deals = response.data.deals.reverse()
                setLead({
                    ...response.data,
                    deals: deals
                })

            }
        })
    }

    useEffect(()=>{
        getLeadData()
    }, [])

    const onChangePage = (listData) => {
        setFeedbacks([...listData])
    }
    const onChangeAppointment = (listData) => {
        setAppointments([...listData])
    }
    const onChangeActivities = (listData) => {
        setActivities([...listData])
    }

    const onChangeDeals = (listData) => {
        setDeals([...listData])
    }

    const custimizeQueries = (query) => {
        const custimizedQuery = []
        for (let key in query) {
            if (query[key] !== "" && key !== "query" && key !== "id" && key !== "date") {
                if (typeof (query[key]) === "object") {
                    let str = `${key.replace('_ids', ' ').replace('_', ' ')} : `
                    const arr = query[key]
                    arr.forEach(item => {
                        // str=str+" , "+item.name.en
                        str = str === `${key.replace('_ids', ' ').replace('_', ' ')} : ` ? str + "  " + item.name.en : str + " , " + item.name.en
                    })
                    custimizedQuery.push(`${str}`)

                } else {
                    if (key === "keyword") {
                        custimizedQuery.push(`name : ${query[key]}`)

                    } else {
                        custimizedQuery.push(`${key.replace('_ids', ' ').replace('_', ' ')} : ${query[key]}`)
                    }
                }

            }
        }
        return custimizedQuery
    }


    const changeStateHandler = (status) => {
        const data = {
            status
        }
        clientsService.update(lead.id, data).then(res => {
            if (res && res.status === SuccessOk) {
                setLead({ ...lead, status })
                toast.success("Status changed successfully")
            }
        })
    }

    return (
        <React.Fragment>
            <div className='page-content view-lead-page'>
                <MetaTags>
                    <title>view client</title>
                </MetaTags>
                <Container fluid>
                    <Row>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col md={6}>
                                        <h4>
                                            <button className="p-0 m-0 border-0 bg-light"
                                                onClick={() => {
                                                    props.history.push(`${salesDeveloperPrefix}/manage-clients`)
                                                }}>
                                                <i className="fa fa-arrow-left text-success me-2"></i>
                                            </button>
                                            View Client
                                  <span className="mx-2">
                                                <Dropdown color="light" isOpen={dropdownStatus} toggle={toggleStausDropdown}>
                                                    <DropdownToggle >
                                                        <Badge
                                                            className="bgBadge-admin font-size-14 m-0 text-white"
                                                            style={{ background: getLeadBackGround(lead ?.status) }}
                                                        >
                                                            {lead ?.status} <i className="fas fa-chevron-down text-white"></i>
                                                        </Badge>
                                                    </DropdownToggle>
                                                    {isExist("manage_client_status") && <DropdownMenu>
                                                        {lead ?.status && ["Wrong number", "Unreachable", "Busy", "Not interested", "Not yet", "Interested to buy", "Interested to sell", "VIP", "Deal", "Contracting"].filter(item => item !== lead ?.status)?.map((status, index) => {
                                                            return (
                                                                <DropdownItem key={index} onClick={() => changeStateHandler(status)}>{status}</DropdownItem>
                                                            )
                                                        })}
                                                    </DropdownMenu>}
                                                </Dropdown>
                                            </span>
                                        </h4>
                                    </Col>
                                    <Col md={6}></Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="w-100 mt-2 px-0">
                            <CardBody className="pb-0">
                                <Row className="mb-4">
                                    <Row className="mb-0">

                                        <h5>Basic Info</h5>
                                        <p>All the information related to the client</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row className="mb-0 mx-1">
                                        <Col md={2}>
                                            <Row className="font-size-14 fw-bold" style={{ opacity: .5 }}>Client Name</Row>
                                            <Row className="font-size-14 fw-bold mt-1">{lead ?.name}</Row>
                                        </Col>
                                        <Col md={2}>
                                            <Row className="font-size-14 fw-bold" style={{ opacity: .5 }}>Phone</Row>
                                            <Row className="font-size-14 fw-bold mt-1">{lead ?.phone}</Row>
                                        </Col>
                                        {/* <Col md={2}>
                                            <Row className="font-size-14 fw-bold" style={{ opacity: .5 }}>Address</Row>
                                            <Row className="font-size-14 fw-bold mt-1">{lead?.email}</Row>
                                        </Col> */}
                                        <Col md={3}>
                                            <Row className="font-size-14 fw-bold" style={{ opacity: .5 }} >Email</Row>
                                            <Row className="font-size-14 fw-bold mt-1">{lead ?.email}</Row>
                                        </Col>
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="w-100 mt-2 px-0">
                            <CardBody className="pb-0">
                                <Row className="mb-4">
                                    <Row className="mb-0">

                                        <h5>Deals</h5>
                                        <p>All the information related the  deals</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <div className="table-view-lead">
                                        <Table>
                                            <thead>
                                                <tr className="bgHeaderTable">
                                                    <th className="font-size-14">Unit</th>
                                                    <th className="font-size-14">Location</th>
                                                    <th className="font-size-14">Compound</th>
                                                    <th className="font-size-14">Property Type</th>
                                                    <th className="font-size-14">Size</th>
                                                    <th className="font-size-14">Budget</th>

                                                    <th className="font-size-14">Creation Date</th>

                                                    <th className="font-size-14">Status</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {deals ?.map((deal, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            {deal.unit ? <>
                                                                <th className="font-size-14">{deal?.unit?.id}</th>
                                                                <th className="font-size-14">{deal?.unit?.area?.name?.en}</th>
                                                                <th className="font-size-14">{deal?.unit?.compound?.name?.en}</th>
                                                                <th className="font-size-14">{deal?.unit?.unit_type?.name?.en}</th>
                                                                <th className="font-size-14">{deal?.unit?.size} m</th>
                                                                <th className="font-size-14">{toCurrency(deal?.unit?.price)}</th>
                                                            </> : <>
                                                                <th className="font-size-14">{deal?.resale?.id}</th>
                                                                <th className="font-size-14">{deal?.resale?.location?.area?.en ? deal?.resale?.location?.area?.en : "-"}</th>
                                                                <th className="font-size-14">{deal?.resale?.compound?.name?.en ? deal?.resale?.compound?.name?.en : "-"}</th>
                                                                <th className="font-size-14">{deal?.resale?.resale_type?.name?.en}</th>
                                                                <th className="font-size-14">{deal?.resale?.total_built_up_area} m</th>
                                                                <th className="font-size-14">{toCurrency(deal?.resale?.price)}</th>
                                                            </>}
                                                            <th className="font-size-14">{deal?.created_at}</th>
                                   
                                                            <th className="font-size-14 ">
                                                                <Badge
                                                                    className="bgBadge-admin font-size-14 m-0 text-white"
                                                                    style={{ background: getDealBackGround(deal ?.status) }}>{deal ?.status}
                                                                </Badge>
                                                            </th>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                        {lead ?.deals ?.length ?
                                            <Row className="d-flex justify-content-end">
                                                <Pagination items={lead ?.deals} onChangePage={onChangeDeals} />
                                            </Row> : null
                                                }
                                    </div>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="w-100 mt-2 px-0">
                            <CardBody className="pb-0">
                                <Row className="mb-4">
                                    <Row className="mb-0">

                                        <h5>Open Properties</h5>
                                        <p>All the information related opened properties</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <div className="table-view-lead">
                                        <Table>
                                            <thead>
                                                <tr className="bgHeaderTable">
                                                    <th className="font-size-14 ">Unit Code</th>
                                                    <th className="font-size-14 ">Compound</th>
                                                    <th className="font-size-14 ">Payment</th>
                                                    <th className="font-size-14 ">Type</th>
                                                    <th className="font-size-14 ">Price</th>
                                                    <th className="font-size-14 ">Size</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lead?.opend_units?.map((unit, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th className="font-size-14 ">{unit.name.en}</th>
                                                            <th className="font-size-14 ">{unit?.compound?.name?.en}</th>
                                                            <th className="font-size-14 ">{unit.installment ? unit.installment : `Cash`}</th>
                                                            <th className="font-size-14 ">
                                                                <Badge
                                                                    className="bgBadge-admin font-size-14 m-0 text-primary"
                                                                    style={{ background: "#e0e9f0" }}>{unit.unit_type.name.en}
                                                                </Badge>
                                                            </th>
                                                            <th className="font-size-14 ">{toCurrency(unit.price)}</th>
                                                            <th className="font-size-14 ">{unit.size}</th>

                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="w-100 mt-2 px-0">
                            <CardBody className="pb-0">
                                <Row className="mb-4">
                                    <Row className="mb-0">

                                        <h5>Open Resales</h5>
                                        <p>All the information related opened Resales</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <div className="table-view-lead">
                                        <Table>
                                            <thead>
                                                <tr className="bgHeaderTable">
                                                    <th className="font-size-14 ">Resale Name</th>
                                                    <th className="font-size-14 ">Compound</th>
                                                    <th className="font-size-14 ">Payment</th>
                                                    <th className="font-size-14 ">Type</th>
                                                    <th className="font-size-14 ">Price</th>
                                                    <th className="font-size-14 ">Size</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lead?.opend_resales?.map((resale, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <th className="font-size-14 ">{resale.name?.en}</th>
                                                            <th className="font-size-14 ">{!!resale?.compound?.name?.en ? resale?.compound?.name?.en : '-'}</th>
                                                            <th className="font-size-14 ">{resale.payment_plan?.payment_method}</th>
                                                            <th className="font-size-14 ">
                                                                <Badge
                                                                    className="bgBadge-admin font-size-14 m-0 text-primary"
                                                                    style={{ background: "#e0e9f0" }}>{resale.resale_type.name.en}
                                                                </Badge>
                                                            </th>
                                                            <th className="font-size-14 ">{toCurrency(resale.payment_plan?.total_price)}</th>
                                                            <th className="font-size-14 ">{resale?.total_built_up_area ? resale.total_built_up_area : '-'}</th>

                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="w-100 mt-2 px-0">
                            <CardBody className="pb-0">
                                <Row className="mb-4">
                                    <Row className="mb-0">

                                        <h5>Compared Compounds</h5>
                                        <p>All the informations related to Compared Compounds</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <div className="table-view-lead">
                                        <Table>
                                            <thead>
                                                <tr className="bgHeaderTable" >
                                                    <th className="font-size-14 " style={{ borderBottom: "2px solid rgba(0, 0, 0, .2)" }}>Compounds</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lead ?.compared_compounds ?.map((item, index) => {
                                                    return (
                                                        <Row key={index} className="mx-0">
                                                            <Col md={12} style={{ background: "#eff2f7" }}>{item.date}</Col>
                                                            {item?.compounds?.map((compound, index) => {
                                                                const image = compound.images[0]
                                                                return (
                                                                    <Col md={4} key={index} className=" border-bottom" style={{ borderRight: item.compounds.length > index + 1 ? ".3px solid rgba(0,0,0,.2)" : "none" }}>

                                                                        <Row className="position-relative d-flex justify-content-between">
                                                                            {index > 0 && <Col md={1}></Col>}
                                                                            <Col md={2}>
                                                                                <img src={image ?.path ? image ?.path : compoundImg} style={{ width: "50px", height: "50px", borderRadius: "5px" }} />
                                                                            </Col>
                                                                            <Col md={8}>
                                                                                <Row className="mb-1 font-size-13 fw-medium">{compound.name.en}</Row>
                                                                                <Row className="text-muted">starting From {toCurrency(compound.starting_from)} EGP</Row>
                                                                            </Col>
                                                                            {item.compounds.length > index + 1 &&
                                                                                <span className="position-absolute d-block text-white" style={{ height: "20px", width: "39px", top: "35%", right: "-18px", background: "#50A5F1", borderRadius: "3px" }}>vs</span>}
                                                                            {index == 0 && <Col md={1}></Col>}

                                                                        </Row>
                                                                    </Col>
                                                                )
                                                            })}
                                                        </Row>
                                                    )
                                                })}

                                            </tbody>
                                        </Table>
                                    </div>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row>
                        <Card className="w-100 mt-2 px-0">
                            <CardBody className="pb-0">
                                <Row className="mb-4">
                                    <Row className="mb-0">
                                        <h5>Upcoming Appointments and Feedback Log</h5>
                                        <p>Here all the information related to  Appointments and Feedback Log</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row >
                                        <Nav tabs className="mb-1">
                                            <NavItem>
                                                <NavLink
                                                    className="fw-bold"
                                                    style={{ border: "none", borderBottom: activeTab === "1" ? "3px solid blue" : "none" }}
                                                    onClick={() => setActiveTab('1')}
                                                >
                                                    Appointments
                                            </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    className="fw-bold"
                                                    style={{ border: "none", borderBottom: activeTab === "2" ? "3px solid blue" : "none" }}
                                                    onClick={() => setActiveTab('2')}
                                                >
                                                    Feedback Log
                                               </NavLink>
                                            </NavItem>
                                        </Nav>
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="1">
                                                <div className="table-view-lead">
                                                    <Table>
                                                        <thead>
                                                            <tr className="bgHeaderTable">
                                                                <th className="font-size-14 ">Date</th>
                                                                <th className="font-size-14 ">Sales Rep</th>
                                                                <th className="font-size-14 ">Activity Type</th>
                                                                <th className="font-size-14 ">Status</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {appointments.length !== 0 ? appointments ?.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <th className="font-size-14 ">{item.date}</th>
                                                                        <th className="font-size-14 ">{item ?.lead ?.name}</th>
                                                                        <th className="font-size-14 ">{item.type}{item.type === "visit" ?
                                                                            <div>
                                                                                <br />Locaion : {item.location}
                                                                            </div>
                                                                            : null}
                                                                        </th>
                                                                        <th className="font-size-14 "><Badge
                                                                            className="mx-1 bg-primary font-size-14  m-0 text-white p-1"
                                                                        >
                                                                            {item.status}
                                                                        </Badge></th>
                                                                    </tr>
                                                                )
                                                            }) : null}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                {lead ?.appointments ?.length ?
                                                    <Row className="d-flex justify-content-end">
                                                        <Pagination items={lead ?.appointments} onChangePage={onChangeAppointment} />
                                                    </Row> : null
                                                }
                                            </TabPane>
                                        </TabContent>
                                        <TabContent activeTab={activeTab}>
                                            <TabPane tabId="2">
                                                <div className="table-view-lead">
                                                    <Table>
                                                        <thead>
                                                            <tr className="bgHeaderTable">
                                                                <th className="font-size-14 ">Title</th>
                                                                <th className="font-size-14 ">Activity Type</th>
                                                                <th className="font-size-14 ">Description</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {feedbacks.length !== 0 ? feedbacks ?.map((item, index) => {
                                                                return (
                                                                    <tr key={index}>
                                                                        <th className="font-size-14 ">{item.title}</th>
                                                                        <th className="font-size-14 ">{item.activity}</th>
                                                                        <th className="font-size-14 ">
                                                                            {item ?.description ?.split("\n")?.map((item, index) => {
                                                                                return (
                                                                                    <div key={index}>
                                                                                        {item}
                                                                                        <br />
                                                                                    </div>
                                                                                )
                                                                            })}
                                                                        </th>
                                                                    </tr>
                                                                )
                                                            }) : null}
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                {lead ?.feedbacks ?.length ?
                                                    <Row className="d-flex justify-content-end">
                                                        <Pagination items={lead ?.feedbacks} onChangePage={onChangePage} />
                                                    </Row> : null
                                                }
                                            </TabPane>
                                        </TabContent>
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                    <Row className="px-0 ">
                        <Card className="mt-2 px-0  ">
                            <CardBody className="pb-0">
                                <Row className="mb-4  mx-1">
                                    <Row className="mb-0 px-0">
                                        <h5 className="fw-bold">Activity Log</h5>
                                        <p className="font-size-14 text-muted mb-0">Here all the information related to  activities</p>
                                    </Row>
                                    <hr className="mt-1 mb-2" />
                                    <Row className="mb-0 fw-bold">
                                        <div className="table-view-deal">
                                            <Table>
                                                <thead>
                                                    <tr className="bgHeaderTable">
                                                        <th className="font-size-14 ">Date</th>
                                                        <th className="font-size-14 ">Sales Rep</th>
                                                        <th className="font-size-14 ">Activity Type</th>
                                                        <th className="font-size-14 ">Status</th>

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {activities.length !== 0 ? activities ?.map((item, index) => {
                                                        return (
                                                            <tr key={index} >
                                                                <th className="font-size-14 ">{item.date}</th>
                                                                <th className="font-size-14 ">{item.owner}</th>
                                                                <th className="font-size-14 ">{item.activity_type}{item.activity_type === "Visit" ?
                                                                    <div>
                                                                        <br />Locaion : {item.location}
                                                                    </div>
                                                                    : null}
                                                                </th>
                                                                <th className="font-size-14 ">{item.status}</th>
                                                            </tr>
                                                        )
                                                    }) : null}
                                                </tbody>
                                            </Table>
                                            {lead ?.activities ?.length ?
                                                <Row className="d-flex justify-content-end">
                                                    <Pagination items={lead ?.activities} onChangePage={onChangeActivities} />
                                                </Row> : null
                                            }
                                        </div>
                                    </Row>
                                </Row>
                            </CardBody>
                        </Card>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}


const getLeadBackGround = (status) => {
    return status === "Wrong number" ? "#f1874c"
    : status === "Busy" ? "#f1b44c"
        : status === "Not interested" ? "#50a5f1"
            : status === "Not yet" ? "#74788d"
                : status === "Interested to buy" ? "#931b7f"
                    : status === "Unreachable" ? "#556ee6"
                        : status === "Interested to sell" ? "#54188d"
                            : status === "VIP" ? "#6498ac" 
                            :status==="Deal" ? "#34e38f" :"#95788d"
                            

}

const getDealBackGround = (status) => {
    return status === "Contacted" ? "#34e38f"
        : status === "Uncontacted" ? "#74788d"
            : status === "Lost" ? "#bf060b"
                : status === "Won" ? "green"
                    : status === "Open" ? "#50a5f1" :
                        status === "Unreachable" ? "#556ee6" : "#f1874c"

}
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}
export default ViewClientPage
